import { COMMON, ifyouApi, ADMIN } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
/** 플랫폼 관리 - 재화 관리 api */

export const currencySetApi = {
  read: (searchData) =>
    ifyouApi
      .post(`${ADMIN}/currency-list`, {
        search_name: searchData.search_name,
        search_project: String(searchData.search_project),
        search_type: searchData.search_type,
      })
      .then((res) => res.data),
  detail: (currencyId) =>
    ifyouApi
      .post(`${ADMIN}/currency-detail`, {
        currency: currencyId,
      })
      .then((res) => res.data),
  update: ({
    newObjLang,
    newObjBubble,
    detailData,
    newAbility,
    currencyId,
  }) => {
    // console.log(newAbility);
    return ifyouApi
      .post(`${ADMIN}/currency-update`, {
        currency: currencyId,

        connected_project: detailData.connected_project,
        currency_type: detailData.currency_type,
        is_unique: detailData.is_unique,
        consumable: detailData.consumable,
        mission_reward: detailData.mission_reward,
        is_use: detailData.is_use,
        is_coin: detailData.is_coin,
        is_ability: detailData.is_ability,
        model_id: detailData.model_id,
        local_code: detailData.local_code,
        KO: newObjLang.KO,
        EN: newObjLang.EN,
        JA: newObjLang.JA,
        ZH: newObjLang.ZH,
        SC: newObjLang.SC,
        icon_image_id: detailData.icon_image_id,
        resource_image_id: detailData.resource_image_id,
        dev_name: detailData.dev_name,
        abilityList: newAbility,
        bubbleList: newObjBubble,
      })
      .then((res) => res.data);
  },
  sorting: (row) =>
    ifyouApi
      .post(`${ADMIN}/currency-sorting`, { rows: row })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  CurrencyConnectList: (func, projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: func,
        project_id: projectId,
      })
      .then((res) => res)
      .catch((error) => {
        if (error.response) {
          console.log(
            `status: ${error.response.status} / data: ${JSON.stringify(
              error.response.data,
            )}`,
          );
          alert(
            `재화 등록 및 수정을 실패했습니다. \n ** error message: ${error.response.data.koMessage}`,
          );
          return false;
        }
      }),
  AbilityDropDown: (projectId, type, speaker) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownAbility',
        project_id: projectId,
        type: type,
        speaker: speaker,
      })
      .then((res) => res)
      .catch((error) => {
        if (error.response) {
          console.log(
            `status: ${error.response.status} / data: ${JSON.stringify(
              error.response.data,
            )}`,
          );
          alert(
            `드롭다운 로드 실패. \n ** error message: ${error.response.data.koMessage}`,
          );
          return false;
        }
      }),
  AbilityDelete: (currency, ability_id) =>
    ifyouApi
      .post(`${ADMIN}/currency-ability-delete`, {
        currency: currency,
        ability_id: ability_id,
      })
      .then((res) => res),
};

/// 오토메 - 의상 판매 (오토메는 작품 관리 안에 귀속되어 있음.)
export const otomeCurrencyApi = {
  read: (projectId) =>
    ifyouApi
      .post(`${ADMIN}/otome-currency-list`, {
        connected_project: projectId,
      })
      .then((res) => res.data),
  detail: (currency) =>
    ifyouApi
      .post(`${ADMIN}/otome-currency-detail`, {
        currency: currency,
      })
      .then((res) => res.data),
  update: ({ newObjLang, detailData, newAbility }) =>
    ifyouApi
      .post(`${ADMIN}/otome-currency-update`, {
        action: detailData.action,
        connected_project: detailData.connected_project,
        currency: detailData.currency,
        currency_type: detailData.currency_type,
        is_public: detailData.is_public,
        model_id: detailData.model_id,
        local_code: detailData.local_code,
        KO: newObjLang.KO,
        EN: newObjLang.EN,
        JA: newObjLang.JA,
        AR: newObjLang.AR,
        MS: newObjLang.MS,
        ES: newObjLang.ES,
        RU: newObjLang.RU,
        icon_image_id: detailData.icon_image_id,
        resource_image_id: detailData.resource_image_id,
        dev_name: detailData.dev_name,
        price: detailData.price,
        sale_price: detailData.sale_price,
        connected_bg: detailData.connected_bg,
        product_type: detailData.product_type,
        abilityList: newAbility,
      })
      .then((res) => res.data),
};

/** 재화 관리 - 관련 드롭다운 API */
export const fetchCurrencyDropApi = {
  // 캐릭터
  standing: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownCharacterModel',
        project_id: projectId,
      })
      .then((res) => res.data),
  resource: (projectId, currencyType) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getCurrencyResourceDropdown',
        code: currencyType,
        project_id: projectId,
      })
      .then((res) => res.data),
  background: (projectId) =>
    ifyouApi
      .post(`${ADMIN}/currency-bgdropdown`, {
        project_id: projectId,
      })
      .then((res) => res.data),
  // 획득 경로
  otomeProductType: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'standard', code: 'otome_product_type' })
      .then((res) => res.data),
};

/// 재화 타입
export const fetchCurrencyTypeDropApi = () =>
  ifyouApi
    .post(`${COMMON}`, { func: 'standard', code: 'currency_type' })
    .then((res) => res.data);

/// 캐릭터 모델
export const fetchStandingDropApi = (projectId) =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'dropdownCharacterModel',
      project_id: projectId,
    })
    .then((res) => res.data);

/// Live 배경
export const fetchLiveWallpaperDropApi = (projectId) =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'dropdownBackgroundModel',
      project_id: projectId,
    })
    .then((res) => res.data);

/// 아이콘 list
export const fetchCurrencyIconDropApi = (projectId) =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'getCurrencyIconDropdown',
      project_id: projectId,
    })
    .then((res) => res.data);

/// 능력치 list
export const fetchAbilityDropApi = {
  speaker: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownAbility',
        project_id: projectId,
        type: 'speaker',
        speaker: '',
      })
      .then((res) => res.data),
  ability: (projectId, speaker) => {
    return ifyouApi
      .post(`${COMMON}`, {
        func: 'dropdownAbility',
        project_id: projectId,
        type: 'ability',
        speaker: speaker,
      })
      .then((res) => res.data);
  },
};

////////////////////
/// 재화 type 리스트
export const currnecyApis = {
  fetchCurrencyTypeList: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'standard', code: 'currency_type' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  currencyUpdate: (
    currency,
    langData,
    inputData,
    localCode,
    abilityData,
    bubbleList,
  ) =>
    // console.log(langData, currency, inputData, localCode, abilityData, bubbleList, '🙇‍♀️'),
    // console.log(currency, langData, inputData, localCode, abilityData, bubbleList),
    ifyouApi
      .post(`${ADMIN}/currency-update`, {
        currency: currency,
        connected_project: Number(inputData.connected_project),
        currency_type: inputData.currency_type,
        is_unique: inputData.is_unique,
        consumable: inputData.consumable,
        mission_reward: inputData.mission_reward,
        is_use: inputData.is_use,
        is_coin: inputData.is_coin,
        is_ability: inputData.is_ability,
        model_id: inputData.model_id,
        local_code: localCode,
        KO: langData.KO,
        EN: langData.EN,
        JA: langData.JA,
        ZH: langData.ZH,
        SC: langData.SC,
        AR: langData.AR,
        icon_image_id: inputData.icon_image_id,
        resource_image_id: inputData.resource_image_id
          ? inputData.resource_image_id
          : -1,
        dev_name: inputData.dev_name,
        abilityList: abilityData,
        bubbleList: bubbleList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
export const currencyList = async (searchData) => {
  try {
    const response = await ifyouApi.post(`${ADMIN}/currency-list`, {
      search_name:
        searchData.search_name === undefined ? '' : searchData.search_name,
      search_project:
        searchData.search_project === undefined
          ? ''
          : searchData.search_project.toString(),
      search_type:
        searchData.search_type === undefined
          ? ''
          : searchData.search_type.toString(),
    });
    return response.data;
  } catch (error) {}
};
/// 재화 상세 조회
export const currencyDetailList = async (currency) => {
  try {
    const response = await ifyouApi.post(`${ADMIN}/currency-detail`, {
      currency: currency,
    });
    return response.data;
  } catch (error) {}
};
/// 재화 타입 리스트 조회
export const fetchCurrencyTypeList = async () => {
  try {
    const response = await ifyouApi.post(`${COMMON}`, {
      func: 'standard',
      code: 'currency_type',
    });
    return response.data;
  } catch (error) {}
};
/// 리소스 이미지
export const fetchResourceCurrencyList = async (projectId, currencyType) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'getCurrencyResourceDropdown',
      code: currencyType,
      project_id: projectId,
    });
    return res.data;
  } catch (error) {}
};
/// 리소스 이미지- 아이콘
export const fetchIconCurrenyList = async (projectId) => {
  try {
    const response = await ifyouApi.post(`${COMMON}`, {
      func: 'getCurrencyIconDropdown',
      project_id: projectId,
    });
    return response.data;
  } catch (error) {}
};
/// 리소스 이미지 - 월페이퍼
export const fetchBackgroundCurrencyList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/currency-bgdropdown`, {
      project_id: projectId,
    });
    return res.data;
  } catch (error) {}
};
/// 재화 - 월페이퍼 연결 모델 드롭다운 => 라이브배경
export const fetchLiveBackgroundCurrencyList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownBackgroundModel',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {}
};
/// 재화 - 스탠딩 연결 모델 드롭다운
export const fetchStandingCurrencyList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownCharacterModel',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {}
};
/// 재화 - 능력치 드롭다운
export const fetchAbilityCurrencyList = async (projectId, speaker) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownAbility',
      project_id: projectId,
      type: 'ability',
      speaker: speaker,
    });
    return res.data;
  } catch (error) {}
};
/// 재화 - 등록
export const currencyRegister = async (
  langData,
  inputData,
  localCode,
  abilityData,
  bubbleList,
) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/currency-update`, {
      currency: inputData.currency,
      connected_project: Number(inputData.connected_project),
      currency_type: inputData.currency_type,
      is_unique: inputData.is_unique,
      consumable: inputData.consumable,
      mission_reward: inputData.mission_reward,
      is_use: inputData.is_use,
      is_coin: inputData.is_coin,
      is_ability: inputData.is_ability,
      model_id: inputData.model_id,
      local_code: localCode,
      KO: langData.KO,
      EN: langData.EN,
      JA: langData.JA,
      ZH: langData.ZH,
      SC: langData.SC,
      icon_image_id: inputData.icon_image_id,
      resource_image_id: inputData.resource_image_id,
      dev_name: inputData.dev_name,
      abilityList: abilityData,
      bubbleList: bubbleList,
    });
    return res.data;
  } catch (error) {}
};

//재화 수정
export const currencyUpdate = async (
  langData,
  inputData,
  localCode,
  abilityData,
  bubbleList,
) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/currency-update`, {
      currency: inputData.currency,
      connected_project: Number(inputData.connected_project),
      currency_type: inputData.currency_type,
      is_unique: inputData.is_unique,

      consumable: inputData.consumable,
      mission_reward: inputData.mission_reward,
      is_use: inputData.is_use,
      is_coin: inputData.is_coin,
      is_ability: inputData.is_ability,
      model_id: inputData.model_id,
      local_code: localCode,
      KO: langData.KO,
      EN: langData.EN,
      JA: langData.JA,
      ZH: langData.ZH,
      SC: langData.SC,
      icon_image_id: inputData.icon_image_id,
      resource_image_id: inputData.resource_image_id,
      dev_name: inputData.dev_name,
      abilityList: abilityData,
      bubbleList: bubbleList,
    });
    return res.data;
  } catch (error) {}
};
export const deleteCurrencyAbilityApi = async (currency, abilityId) => {
  try {
    const response = await ifyouApi.post(`${ADMIN}/currency-ability-delete`, {
      currency: currency,
      ability_id: abilityId,
    });
    return response.data;
  } catch (error) {}
};
/// 재화 드롭다운 목록
export const fetchCurrencyList = async () => {
  try {
    const response = await ifyouApi.post(`${COMMON}`, {
      func: 'geCurrencyListAll',
      search_word: '',
      kind: 'coinStore',
    });
    const newData = [];
    // response.data.map((v, i) =>
    //   newData.push({ key: i, text: v.origin_name, value: v.currency }),
    // );
    return newData;
  } catch (error) {}
};
/// 재화 - 능력치 캐릭터 드롭다운
export const fetchAbilityCharacterList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'dropdownAbility',
      project_id: projectId,
      type: 'speaker',
      speaker: '',
    });
    return res.data;
  } catch (error) {}
};
